import { module } from 'stereomodularjs';
import { createApp } from "vue/dist/vue.esm-bundler.js"
import CoursesListing from '../components/CoursesListing.vue'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;
        let block = JSON.parse(this.el.dataset.block)

        // generate id on this.el
        //this.el.id = block.id

        const app = createApp({
            template: '<CoursesListing :block="block" />',
            components: {
                CoursesListing
            },
            data() {
                return {
                    block: block
                }
            },
            mounted() {
            },
        })
        app.mount(self.el)
    }
}
